export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: true,
    maxItemsVisible: 5,
    isResponsive: false,
    allEventsLink: true,
    allEventsLinkText: 'view all events',
    link: 'all',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      let eventsQuantity = data.length;

      if (eventsQuantity == 0) {
        $(`#${widgetName}`).remove();
        $('body').addClass('noEvents');
      } else {
        let windowSize = $(window).width();
        let breakpoint = 800;

        $(`#${widgetName}`).prepend('<h2 class="multiScheduleFeature-title">Upcoming Events</h2>');

        $('#multiScheduleFeature').prepend();

        $(`#${widgetName} .featureItem`).each(function (i) {
          let widgetDate = data[i].Date;
          let widgetName = data[i].Name;
          let widgetURL = data[i].URL;
          let widgetImage =
            data[i].ImageURL == ''
              ? `${FULLCLIENTTHEMEPATH}images/NoImageImage.jpg`
              : data[i].ImageURL;

          let fixedDate = widgetDate.split('-');

          let dayStart;
          let monthStart;
          let dayEnd;
          let monthEnd;
          let dateLayout;

          switch (fixedDate.length) {
            case 1:
              dayStart = formatDate(fixedDate, 0, 0, 1);
              monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
              dateLayout = buildEventDateLayout(monthStart, dayStart);
              break;

            case 2:
              monthStart = formatDate(fixedDate, 0, 0, 0);
              dayStart = formatDate(fixedDate, 0, 0, 1);
              monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
              dayEnd = formatDate(fixedDate, 1, 0, 1);
              dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
              break;

            default:
              break;
          }

          $(this).empty();
          $(this).append(buildEventInfoLayout(widgetName, widgetImage, widgetURL));

          if (windowSize > breakpoint) {
            $(this).removeAttr('href');
          }
          if (widgetURL == '') {
            $(this).removeAttr('href');
            $(this).addClass('void');
          }

          $(this).find('.event-info').append(dateLayout);
          if (widgetURL != '') {
            $(this).attr('href', widgetURL);
          }
        });

        $('.all-events-btn').addClass('button');
        $('.all-events-btn').appendTo('#multiScheduleFeature');
        $('.all-events-btn').wrap('<div class="btn-container"></div>');
        if (eventsQuantity < 2) {
          $('.all-events-btn').addClass('singleEvent');
          $('.btn-container').addClass('singleEvent');
          $('#multiScheduleFeature').addClass('singleEvent');
        }
      }
    },
  });
}

function buildEventInfoLayout(title, image, eventUrl) {
  let infoLayout = `
  <div class="img-container">
    ${
      eventUrl
        ? `<div class="overlay">
            <div class="buttonwrap">
              <a class="button" href="${eventUrl}">More</a>
            </div>
          </div>`
        : ''
    }  
    <img src="${image}" alt="${title}" class="event-image">
  </div>
  <div class="event-info">
    <span class="event-name">${title}</span>
  </div>`;

  return infoLayout;
}

function formatDate(date, slot1, slot2, slot3) {
  let splittedDate = date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
  return splittedDate;
}

function buildEventDateLayout(
  eventStartMonth,
  eventStartDay,
  eventEndMonth = null,
  eventEndDay = null,
) {
  let dateLayout;
  if (eventEndMonth === null || eventEndDay === null) {
    dateLayout = `
          <div class="event-date ">
              <span class="month">${eventStartMonth}</span>
              <span class="day">${eventStartDay}</span>
          </div>`;
  } else if (eventStartMonth == eventEndMonth) {
    dateLayout = `
          <div class="event-date double-date">
              <span class="month">${eventStartMonth}</span>
              <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
          </div>`;
  } else {
    dateLayout = `
          <div class="event-date date-range">
              <div class="combo-date">
                  <span class="month">${eventStartMonth}</span>
                  <span class="day">${eventStartDay}</span>
                  </div>
                  
              <span class="separator-month">-</span>

              <div class="combo-date">
                  <span class="month">${eventEndMonth}</span>
                  <span class="day">${eventEndDay}</span>
              </div>
          </div>`;
  }
  return dateLayout;
}
